module.exports = __webpack_public_path__ + "static/media/contact_us_header_banner2.e22bf177.jpg";